import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Chart from "react-apexcharts";
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import { useDispatch, useSelector } from "react-redux";
import TimelineContent from '@mui/lab/TimelineContent';
import { Grid, Paper, Typography } from "@mui/material";
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';

import { S3_BUCKET } from "../../constants";
import { profileActions } from "../../store/actions";
import useStyles, { StyledTimeline } from "./Styles/DashboardStyles";
import { useNonInitialEffect } from "../../hooks/UseNonInitialEffect";
import { options, donationsData } from "../../helpers/ApexChartConfig";
import { MuiAvatar, ProfileDonationDetailCard } from "../../components";
import { CalendarIcon, AllTimeDonationsIcons } from "../../components/Icons";
import UserActivitySkeleton from "../../components/skeletons/UserActivitySkeleton";

export default function Dashboard() {
    const currentYear = new Date().getFullYear();
    const classes = useStyles();
    const dispatch = useDispatch();
    const user = useSelector(state => state.authentication.current_user);
    const graphData = useSelector(state => state.profile.user_graph_data);
    const userActivities = useSelector(state => state.profile.user_activities);

    const [donationsGivenGraph, setDonationsGivenGraph] = useState(donationsData.given);
    const [donationsReceivedGraph, setDonationsReceivedGraph] = useState(donationsData.received);
    const [currentYearDonations, setCurrentYearDonations] = useState(0);
    const [allTimeDonations, setAllTimeDonations] = useState(0);
    const [donationsCurrency, setDonationsCurrency] = useState("");

    const renderActivities = () => {
        return userActivities.map((activity, index) => {
            return <TimelineItem key={activity.id}>
                <TimelineOppositeContent>
                    <MuiAvatar src={S3_BUCKET + user.avatar} fullName={user.name} />
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot color="primary" />
                    <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ p: 0, pb: index == userActivities.length - 1 ? 0 : 5 }}>
                    <Typography color='primary'>
                        {user.name} <Typography component="span" color='neutral.dark'>{activity.created_at}</Typography>
                    </Typography>
                    <Typography>{activity.log_name}</Typography>
                </TimelineContent>
            </TimelineItem>
        })
    }

    const setDonationChartData = () => {
        setDonationsCurrency(graphData.donation_currency);
        setAllTimeDonations(graphData.total_donations_amount);
        setCurrentYearDonations(graphData.total_donations_yearly);

        const donationsReceivedData = { ...donationsData.received, data: [] };
        const donationsGivenData = { ...donationsData.given, data: [] };

        if (graphData.donations_given.length) {
            graphData.donations_given.map(data => {
                donationsGivenData.data.push(Math.round(data.monthly_donation))
            });
        }
        else donationsGivenData.data.push(0)

        if (graphData.donations_received.length) {
            graphData.donations_received.map(data => {
                donationsReceivedData.data.push(Math.round(data.monthly_donation))
            })
        }
        else donationsReceivedData.data.push(0)

        setDonationsGivenGraph(donationsGivenData);
        setDonationsReceivedGraph(donationsReceivedData);
    }

    useEffect(() => {
        if (user) {
            if (!userActivities) dispatch(profileActions.getUserActivities(user.id));
            if (!graphData) dispatch(profileActions.getUserGraphData(user.id));
            else setDonationChartData()
        }
    }, [user])

    useNonInitialEffect(() => {
        setDonationChartData()
    }, [graphData])

    return <Grid container spacing={4}>
        <Grid item md={6} sm={12} xs={12}>
            <ProfileDonationDetailCard amount={allTimeDonations} label={`${currentYear} Donations`} Icon={<CalendarIcon width='65px' />} backgroundColor='#FFCC00' />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
            <ProfileDonationDetailCard amount={currentYearDonations} label='All Time Donations' Icon={<AllTimeDonationsIcons width='65px' color="white" />} color="white" backgroundColor='#00884C' />
        </Grid>
        <Grid item xs={12}>
            <Chart
                options={options(donationsCurrency)}
                series={[donationsGivenGraph, donationsReceivedGraph]}
                type="line"
                width="100%" />
        </Grid>
        <Grid item xs={12} className={classes.activityContainer}>
            <Box>
                <Paper elevation={0} className={classes.textContainer}>
                    <Typography className={classes.acivityText}>Your Activity</Typography>
                </Paper>
            </Box>
            <StyledTimeline>
                {user && userActivities ? renderActivities() : <UserActivitySkeleton/>}
            </StyledTimeline>
        </Grid>
    </Grid>
}